<template>
  <div ref="descriptionBanner" class="c-banner__introduction" />
  <div ref="descriptionHtmlElement" class="c-banner__introduction">{{ description }}</div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue'

const props = defineProps<{
  description: string
}>()

const description = ref(props.description)
const htmlContent = ref<HTMLElement>()

const tags = [ 'banner-success', 'banner-error', 'banner-warning' ]

const descriptionBanner = ref()
const descriptionHtmlElement = ref()

function parseDescription () {
  for (let i = 0; i < tags.length; i++) {
    if (description.value.includes('<' + tags[i] + '>')) {
      parseHtml(tags[i])
    }
  }
}

function parseHtml (tagName: string) {
  // get string html content
  const startTag = '<' + tagName + '>'
  const startIndex = description.value.indexOf(startTag)

  const endTag = '</' + tagName + '>'
  const endIndex = description.value.indexOf(endTag) + endTag.length

  const str = ref(description.value.substring(startIndex, endIndex))
  str.value = str.value.substring(str.value.indexOf(startTag) + startTag.length, str.value.indexOf(endTag))

  // remove tag in original description
  const rawStr = startTag + str.value + endTag
  description.value = description.value.replace(rawStr, '')

  // create new HTML element from string
  const htmlElement = document.createElement('div')
  htmlElement.classList.add('c-project__description-' + tagName)
  htmlElement.innerHTML = str.value

  htmlContent.value = htmlElement

  // add html element to description
  if (tagName.includes('banner')) {
    htmlElement.classList.add('c-project__description-banner')
    descriptionBanner.value.appendChild(htmlContent.value)
  } else {
    descriptionHtmlElement.value.appendChild(htmlContent.value)
  }
}

onMounted(() => {
  parseDescription()
})
</script>
